import React, { Component } from 'react'
import { Action } from 'hljd'
import { observer } from 'mobx-react'
const Item = Action.Item
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.props.store.getInfo()
  }
  handleChange = key => {
    const { onChange } = this.props
    onChange && onChange(key)
  }
  render() {
    const { active } = this.props
    return (
      <Action active={active} onChange={this.handleChange}>
        <Item value="1">
          <span>潜在客资</span>
        </Item>
        <Item value="2">
          <span>推送列表</span>
        </Item>
      </Action>
    )
  }
}
